import React from 'react'
import { useAppSelector } from 'reduxTyped'
import { Loader, isMobile } from '@manychat/manyui'

import { isBuilderEmptyState } from 'common/builder/selectors/builder/commonSelectors'
import { analyticsService, flowBuilderEvents } from 'utils/services/analytics'

import app from './app'
import { SIDEBAR_WIDTH, SIDEBAR_CLOSE_WIDTH } from './config'

function basicFlowChart(WrappedComponent) {
  class BasicFlowChart extends React.Component {
    state = {
      showFlowChart: true,
      imageSrc: null,
    }

    handleNodeClick = (e, nodeId) => {
      if (this.props.player) {
        return app.moveTo(nodeId)
      }

      const { originalEvent } = e.data

      if (originalEvent && originalEvent.shiftKey) {
        this.props.toggleSelection(nodeId)
      } else {
        const node = app.getNode(nodeId)
        analyticsService.logFlowBuilderEvent(flowBuilderEvents.SELECT_NODE, { node })
        this.props.showSidebar()

        const nodeGlobalPosition = app.getNodeGlobalPosition(node)
        const overlaidWidth = SIDEBAR_WIDTH - nodeGlobalPosition.x

        if (overlaidWidth > 0 && !isMobile) {
          const scaledShift = (overlaidWidth + SIDEBAR_CLOSE_WIDTH) / app.transform.k
          app.moveBy(scaledShift, 0)
        }

        const { selected } = this.props
        const selectedKeys = Object.keys(selected)
        if (selectedKeys.length === 1 && selectedKeys[0] === nodeId) {
          return
        }

        this.props.openNode(nodeId, { dropHistory: true })
      }
    }

    render() {
      const { player, userFieldsFetching, globalFieldsFetching } = this.props
      const { showFlowChart } = this.state
      const { imageSrc, imageWidth, imageHeight, imageOpacity, imageBlur } = this.state

      const isFetching = userFieldsFetching || globalFieldsFetching
      const showComponent = player || (!player && !isFetching)

      return (
        <>
          {showFlowChart && (
            <>
              {showComponent ? (
                <WrappedComponent onNodeClick={this.handleNodeClick} {...this.props} />
              ) : (
                <Loader center />
              )}
            </>
          )}
          {Boolean(imageSrc) && (
            <>
              <img
                width={imageWidth}
                height={imageHeight}
                className="p-absolute p-stretched"
                src={imageSrc}
                style={{
                  background: '#F2F5F7',
                  transition: 'all 1.5s ease-in',
                  opacity: imageOpacity,
                  filter: `blur(${imageBlur}px)`,
                }}
              />
              <Loader center />
            </>
          )}
        </>
      )
    }
  }

  const BasicFlowChartWrapper = (props) => {
    const { userFieldsFetching, globalFieldsFetching } = useAppSelector((state) => ({
      userFieldsFetching: Boolean(state.userFields?.fetching),
      globalFieldsFetching: Boolean(state.globalFields?.fetching),
    }))

    const isChooseFirstStepNodeVisible = useAppSelector((state) =>
      isBuilderEmptyState(state, props.builderId),
    )

    return (
      <BasicFlowChart
        {...props}
        isChooseFirstStepNodeVisible={isChooseFirstStepNodeVisible}
        userFieldsFetching={userFieldsFetching}
        globalFieldsFetching={globalFieldsFetching}
      />
    )
  }

  return BasicFlowChartWrapper
}

export default basicFlowChart
